/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OrgAppDeviceForm from './OrgAppDeviceForm';
import { editOrgApplicationDevice } from '../../../../../../../../services/organization/OrgApplicationDevices';
import { getAllOrgApplicationDevices } from '../../../../../../../../store/reducers/organization/orgApplicationDevices/orgApplicationDevicesAction';

const OrgAppDeviceEdit = ({ handleClose, selectedOrgAppDevice }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ roleID, detailName, detailValue }, { setSubmitting }) => {
        try {
            setSubmitting(true)

            await editOrgApplicationDevice({
                roleID, organizationApplicationDeviceID: selectedOrgAppDevice.organizationApplicationDeviceID, organizationApplicationDeviceDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Organization Application Device was edited successfully');
            handleClose();
            await dispatch(getAllOrgApplicationDevices()).unwrap();
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application Device Edit</Typography>
            <Formik
                initialValues={{
                    roleID: selectedOrgAppDevice.roleID,
                    detailName: selectedOrgAppDevice.organizationApplicationDeviceDetails[0].detailName,
                    detailValue: selectedOrgAppDevice.organizationApplicationDeviceDetails[0].detailValue,

                }}
                validationSchema={Yup.object().shape({
                    roleID: Yup.string().required('Role is required.')
                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                    <OrgAppDeviceForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgAppDeviceEdit;
